export const localProxy = process.env.LOCAL_PROXY;
const useLocalProxy = !!localProxy;

let appRoute;
if (process.env.NODE_ENV === 'production') {
  appRoute = window.location.origin;
} else if (useLocalProxy) {
  appRoute = localProxy;
} else if (window.location.hostname === 'localhost') {
  appRoute = 'http://localhost:1234';
} else {
  appRoute = `${window.location.hostname}:1234`;
}
export const HATCH_APP_ROUTE = appRoute;

// production server URLS
export const PROD_URL = 'prod.usehatchapp.com';
export const BETA_URL = 'beta.usehatchapp.com';

// is on production server
export const isProductionServer =
  window.location.hostname === BETA_URL ||
  window.location.hostname === PROD_URL;

// is on local development server
export const isLocalServer = window.location.hostname === 'localhost';

// default route
export const ROOT = '/account';
export const DEV_ROOT = '/';
export const DEV_ROOT_EMPTY = '';

export const LOGIN = '/login';

// app routes
export const BILLING = `${ROOT}/organization/:organizationId/billing`;
export const GENERAL = `${ROOT}/organization/:organizationId/general`;
export const TEAM = `${ROOT}/organization/:organizationId/team`;
export const WORKSPACE = `${ROOT}/organization/:organizationId/workspace`;
export const COMPLIANCE = `${ROOT}/organization/:organizationId/compliance`;

// Compliance routes
export const COMPLIANCE_10LDC_FAKE_URL = `${ROOT}/compliance`;
export const COMPLIANCE_10LDC_FORM_URL = `${ROOT}/organization/[[organizationID]]/compliance`;

// Error routes
export const ERROR = `${ROOT}/error`;

// URLs available without being authenticated
export const PUBLIC_URLS = [DEV_ROOT, DEV_ROOT_EMPTY, ROOT, ERROR];

// PUBLIC_URLS excluding the error route to redirect to
export const PUBLIC_URLS_WITHOUT_ERROR_REDIRECT = [
  DEV_ROOT,
  DEV_ROOT_EMPTY,
  ROOT,
];

// URLs only available when authenticated
export const PRIVATE_URLS = [BILLING, GENERAL, TEAM, WORKSPACE];

// slideout card constants
export const ADD_WORKSPACE = 'addWorkspace';
export const EDIT_WORKSPACE = 'editWorkspace';
export const ADD_MEMBER = 'addMember';
export const EDIT_MEMBER = 'editMember';

// confirmation constants
export const CONFIRM_ARCHIVE_WORKSPACE = 'archiveWorkspace';
export const CONFIRM_ARCHIVE_MEMBER = 'archiveMember';

export const REDIRECT_PATHS = {
  [COMPLIANCE_10LDC_FAKE_URL]: COMPLIANCE_10LDC_FORM_URL,
};
